import { reactive } from "vue";
export const state = reactive({
  showProfileUpdateView: false,
  isProfileDataLoading:true,
  favoriteDocumentChange:{docId: null, isFavorite:false},
  reloadDocuments:false,
  searchFocus: false,
  lastUpdatedProject:null
});

export const getApplicationState = {
  getProfileUpdateStatus() {
    return state.showProfileUpdateView;
  },
  getProfileDataLoadingStatus(){
    return state.isProfileDataLoading
  },
  setFavoriteDocumentChange(){
    return state.favoriteDocumentChange
  },
  getDocumentReloadState(){
    return state.reloadDocuments;
  },
  getSearchFocusState(){
    return state.searchFocus;
  },
  getLastUpdatedProject() {
    return state.lastUpdatedProject;
  },
};

export const setApplicationState = {
  setProfileUpdateStatus(status) {
    state.showProfileUpdateView = status;
    return;
  },
  setProfileDataLoadingStatus(status){
    state.isProfileDataLoading = status
    return;
  },
  setFavoriteDocumentChange({docId,isFavorite}){
    state.favoriteDocumentChange = {docId,isFavorite}
    return;
  },
  setDocumentReloadState(status){
    state.reloadDocuments = status;
    return
  },
  setSearchFocusState(status){
    state.searchFocus = status;
    return;
  },
  setLastUpdatedProject(project) {    
    state.lastUpdatedProject = project;    
    return;
  }
};

const store ={ getApplicationState,setApplicationState};
export default store;
